import { useTranslation } from "react-i18next";

const WelcomeBanner = () => {
    const { t } = useTranslation(['Dashboard']);

    return (
        <div className="card dashboard-welcome-banner mb-4">
            <div className="card-body">
                <div className="row align-items-center">
                    <div className="col-sm-9">
                        <div className="dashboard-welcome-banner__content p-3">
                            <h2 className="text-white mb-2">{t('welcomeBanner.title')}</h2>
                            <p className="text-white mb-0">{t('welcomeBanner.description')}</p>
                        </div>
                    </div>
                    <div className="col-sm-3 dashboard-welcome-banner__logo-col">
                        <div className="dashboard-welcome-banner__logo-wrap">
                            <div className="dashboard-welcome-banner__logo-glow" aria-hidden="true" />
                            <img
                                src="/preview.webp"
                                alt={t('welcomeBanner.title')}
                                className="dashboard-welcome-banner__logo img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeBanner;
